import { ITariffState, ITariffTypeVisual } from '@/store/tariff';
import { ITariffGetters } from './getters.types';
import { ITariff, Tariff } from '@/models';

export const getters: ITariffGetters = {
  getTariffRates(state: ITariffState): ITariff[] {
    return state.tariffs.map(data => new Tariff(data));
  },

  getTariffRateById: (state: ITariffState) => (
    id: number
  ): ITariff | undefined => {
    const data = state.tariffs.find(tariff => tariff.id === id);
    if (!data) {
      return undefined;
    }

    return new Tariff(data);
  },

  getTariffTypeVisuals: (state: ITariffState): ITariffTypeVisual[] => {
    return state.tariffTypeVisuals;
  },

  getTariffTypeVisualByType: (state: ITariffState) => (
    type: ITariffTypeVisual['value']
  ): ITariffTypeVisual | undefined => {
    return state.tariffTypeVisuals.find(visual => visual.value === type);
  }
};
